/**
 * Утилита для работы с типами нот (клиентская часть)
 * Использует общий файл shared/noteTypes.json для синхронизации с сервером
 */

import noteTypesData from '../../../shared/noteTypes.json';

const NOTE_TYPES = noteTypesData.NOTE_TYPES;
const NOTE_TYPE_LABELS = noteTypesData.NOTE_TYPE_LABELS;

/**
 * Получить массив всех типов нот с лейблами (отсортированный по алфавиту)
 * @returns {Array<{value: string, label: string}>}
 */
const getAllNoteTypes = () => {
  return Object.values(NOTE_TYPES)
    .map(value => ({
      value,
      label: NOTE_TYPE_LABELS[value]
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

/**
 * Список всех доступных типов нот для использования в компонентах
 */
export const noteTypes = getAllNoteTypes();

/**
 * Получить лейбл типа ноты по значению
 * @param {string} value - Значение типа ноты
 * @returns {string} - Лейбл типа ноты или сам value если не найден
 */
export const getNoteTypeLabel = (value) => {
  return NOTE_TYPE_LABELS[value] || value;
};

/**
 * Получить объект типа ноты по значению
 * @param {string} value - Значение типа ноты
 * @returns {object|null} - Объект типа ноты или null если не найден
 */
export const getNoteType = (value) => {
  return noteTypes.find(type => type.value === value) || null;
};

/**
 * Проверить, существует ли тип ноты
 * @param {string} value - Значение типа ноты
 * @returns {boolean} - true если тип существует
 */
export const isValidNoteType = (value) => {
  return Object.values(NOTE_TYPES).includes(value);
};

/**
 * Получить типы нот для select компонента
 * @returns {array} - Массив объектов для react-select
 */
export const getNoteTypesForSelect = () => {
  return noteTypes;
};

const NOTE_TYPE_COLORS = {
  general:   '#6B7280',
  admin:     '#EF4444',
  courses:   '#3B82F6',
  sub_title: '#8B5CF6',
  team_lead: '#10B981',
  manager:   '#F59E0B',
  computer:  '#0EA5E9',
  other:     '#9CA3AF',
};

/**
 * Отримати HEX-колір для типу ноти
 * @param {string} value
 * @returns {string}
 */
export const getNoteTypeColor = (value) => {
  return NOTE_TYPE_COLORS[value] || '#9CA3AF';
};

/**
 * Константы типов нот
 */
export { NOTE_TYPES, NOTE_TYPE_LABELS };

